/* eslint-disable jira/filename-case */
import type { MemoExoticComponent } from 'react';
import { lazyAfterPaint, lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type HorizontalNavQueue from './ui/HorizontalNavQueue.tsx';

export const LazyHorizontalNavQueue: LazyComponent<MemoExoticComponent<() => React.JSX.Element>> =
	lazyAfterPaint<typeof HorizontalNavQueue>(
		() =>
			import(
				/* webpackChunkName: "async-horizontal-nav-queue" */ './ui/HorizontalNavQueue.tsx'
			).then((HorizontalNavQueue) => HorizontalNavQueue),
		{ includeInShellOnlySsrBundle: true, entryFsSsrLiftImportToModule: true },
	);

export const LazyHorizontalNavQueueForPaint: LazyComponent<
	MemoExoticComponent<() => React.JSX.Element>
> = lazyForPaint<typeof HorizontalNavQueue>(
	() =>
		import(
			/* webpackChunkName: "async-horizontal-nav-queue-for-paint" */ './ui/HorizontalNavQueue.tsx'
		).then((HorizontalNavQueue) => HorizontalNavQueue),
	{ includeInShellOnlySsrBundle: true, entryFsSsrLiftImportToModule: true },
);
